import { FormBase } from 'core/components';

export default class FacilityMissingDocsEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "clinicalStatusId",
                    // label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.CLINICAL_STATUS_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.CLINICAL_STATUS_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: 'note',
                    label: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: "dxCode1",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE1_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE1_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode2",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE2_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE2_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode3",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE3_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE3_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode4",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE4_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE4_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode5",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE5_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE5_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode6",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE6_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE6_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode7",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE7_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE7_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode8",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE8_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.DX_CODE8_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "orderingDoctorId",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.ORDERING_DOCTOR_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.ORDERING_DOCTOR_PLACEHOLDER",
                },
                {
                    name: "facilityOrderTemplateMissingDocuments",
                    label: "FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.MISSING_DOCUMENTS_LABEL",
                },
                {
                    name: 'swo',
                    label: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.EXPIRATION_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_CLINICAL.EDIT.EXPIRATION_DATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'height',
                    label: 'Height (in.)',
                    placeholder: ''           
                },
                {
                    name: 'weight',
                    label: 'Weight (lbs.)',
                    placeholder: ''                  
                }
            ],
        };
    }
}
